import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`If there are elements you don't want to be captured, you can add the `}<inlineCode parentName="p">{`ph-no-capture`}</inlineCode>{` property. If this property is found anywhere in the view hierarchy, the entire touch event is ignored:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-react-native"
      }}>{`<View ph-no-capture>Sensitive view here</View>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      